/**
 * Feature Flag Keys
 *
 * Only flags that are actively gated in code belong here.
 * All previously gated features have been retired (gates removed, always-on).
 *
 * Remaining flags are safety-valve / infrastructure toggles managed
 * directly in the backend cron services and seed files.
 */

export const FEATURE_FLAGS = {
  BOOK_NOW: 'book-now',
  VENUE_LEADERBOARD: 'venue-leaderboard',
  PC_ANALYTICS: 'pc-analytics',
  PC_MANAGEMENT: 'pc-management-module',
  CUSTOMER_WALLET: 'customer-wallet',
  CUSTOMER_REWARDS: 'customer-rewards',
  CUSTOMER_BADGES: 'customer-badges',
  CUSTOMER_REFERRAL: 'customer-referral',
  VENDOR_BILLING: 'vendor-billing',
  COMPETITIVE_LEADERBOARD: 'competitive-leaderboard',
  PC_UNLOCK: 'pc-agent',
  PC_SCAN_UNLOCK: 'pc-scan-unlock',
  LORD_COINS_WALLET: 'lord-coins-wallet',
  PC_AGENT_LAUNCHER: 'pc-agent-launcher',
} as const;

export type FeatureFlagKey = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];
